import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-afa2cbf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cinema__collection"
}
const _hoisted_2 = { class: "cinema__collection-title" }
const _hoisted_3 = {
  key: 0,
  class: "cinema__collection-pagination"
}
const _hoisted_4 = { class: "pagination-page" }
const _hoisted_5 = ["data-collection-id", "data-collection-col"]

import { ref, watch, computed } from 'vue'
import CinemaCard from '@remote/components/cinema/CinemaCard.vue'
import { IconPageLeft } from '@xunlei/thunder-icon-vue'
// import { useScrollCollection } from '@shared/composable/cinema'
import { useCinemaCollectionPagation } from '@remote/composable/cinema'
import { v4 as uuidv4 } from 'uuid'

interface IProps {
  type: 'recent_watch' | 'recent_add'
  title: string
  nfos: API_NFO.NFO[]
}

export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    title: null,
    nfos: null
  },
  setup(__props: any) {

const props = __props as {
  type: 'recent_watch' | 'recent_add'
  title: string
  nfos: API_NFO.NFO[]
}

const uid = ref(uuidv4())


const orientation = computed<'portrait' | 'landscape'>(() => {
  return props.type === 'recent_watch' ? 'landscape' : 'portrait'
})

const { layout, pagation, canprev, prevPage, cannext, nextPage, updateList } = useCinemaCollectionPagation(uid, props.nfos, orientation.value)
watch(() => props.nfos.length, () => {
  updateList(props.nfos)
})

return (_ctx: any,_cache: any) => {
  return (__props.nfos.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
        (_unref(pagation).visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", {
                class: _normalizeClass(["pagination-left", { disabled: !_unref(canprev) }]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(prevPage) && _unref(prevPage)(...args)))
              }, [
                _createVNode(_unref(IconPageLeft))
              ], 2),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(pagation).page) + "/" + _toDisplayString(_unref(pagation).total), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["pagination-right", { disabled: !_unref(cannext) }]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(nextPage) && _unref(nextPage)(...args)))
              }, [
                _createVNode(_unref(IconPageLeft))
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "cinema__collection-container",
          onTouchend: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
          onTouchmove: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
          onTouchstart: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            class: "collection-container__inner",
            "data-collection-id": uid.value,
            "data-collection-col": _unref(layout).col,
            style: _normalizeStyle({ transform: `translateX(-${(_unref(pagation).page - 1) * 100}%)` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.nfos, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.video_info?.file_id,
                class: _normalizeClass(["cinema__collection-item", [
            `orientation__${_unref(orientation)}`,
            {
              'overview': (index < (_unref(pagation).page - 1) * _unref(layout).col) || (index >= _unref(pagation).page * _unref(layout).col)
            }
          ]]),
                style: _normalizeStyle({ width: _unref(layout).width })
              }, [
                _createVNode(CinemaCard, {
                  nfo: item,
                  type: __props.type === 'recent_watch' ? 'play_history' : 'view_list',
                  "click-from": "index",
                  class: "cinema__collection-card",
                  poster: { orientation: _unref(orientation) }
                }, null, 8, ["nfo", "type", "poster"])
              ], 6))
            }), 128))
          ], 12, _hoisted_5)
        ], 32)
      ]))
    : _createCommentVNode("", true)
}
}

})